import React, {Component} from 'react';
import {graphql, compose} from 'react-apollo';
import userQuery from 'graphql/queries/user.gql';
import termsAndConditionsQuery from 'graphql/queries/terms-and-conditions.gql';
import Spinner from 'components/spinner';
import SectionTitle from 'components/section-title';
import TermsAndConditionsText from 'components/terms-and-conditions-text';
import styles from './styles.css';

@compose(
    graphql(userQuery, {name: 'userData'}),
    graphql(termsAndConditionsQuery, {
        options: props => ({
            variables: {
                token: props.match.params.token,
            },
        }),
    }),
)
export default class TermsAndConditions extends Component {
    componentDidUpdate() {
        const id = (this.props.location.hash || '').replace('#', '');
        const section = document.getElementById(id);

        if (!section) return; // No deeplink

        section.scrollIntoView();
        // Adjust for header
        const headerNode = document.querySelector('[class^="header--root"]');
        window.scrollTo(0, window.scrollY - headerNode.clientHeight);
    }

    render() {
        if (!this.props.data.termsAndConditions) return <Spinner />;

        return (
            <div className={styles.root}>
                <SectionTitle title='Bases y condiciones' />
                <TermsAndConditionsText data={this.props.data.termsAndConditions} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/terms-and-conditions/index.js